import { scrollToY } from "@client/lib/misc";
import * as React from "react";

import "./style.less";

export default class GoToTop extends React.Component {
  private _ref = React.createRef<HTMLDivElement>();

  public componentDidMount() {
    this._updatePosition();

    window.addEventListener("scroll", this._updatePosition);
  }

  public componentWillUnmount() {
    window.removeEventListener("scroll", this._updatePosition);
  }

  public render() {
    return (
      <div className="wsc_go_to_top" ref={this._ref} onClick={this._onClick}>
        <i className="far fa-angle-up top-icon" />
        <i className="far fa-angle-up" />
      </div>
    );
  }

  private _updatePosition = () => {
    const el = this._ref.current as HTMLElement;
    const dataOffset = $("body").attr("data-offset") ?? "";
    const scrollOffset = isNaN(+dataOffset) ? 800 : +dataOffset;
    if (window.scrollY > scrollOffset) {
      $(el).css({
        bottom: "26px",
        opacity: 1
      });
    } else {
      $(el).css({
        bottom: "16px",
        opacity: 0
      });
    }
  };

  private _onClick = (e: React.MouseEvent) => {
    e.preventDefault();

    scrollToY(0, 1500);
  };
}
